import isObject from "../struct-events/is-object.js";
import cloneValue from "./clone-value.js";

function deepAssignProperty(destObject, key, srcSubValue) {
    const destSubValue = destObject[key];

    if (destSubValue === srcSubValue) {
        return;
    }

    if (isObject(destSubValue) && isObject(srcSubValue)) {
        const isArraySubDest = Array.isArray(destSubValue);
        const isArraySubSrc = Array.isArray(srcSubValue);

        if (isArraySubDest === isArraySubSrc) {
            if (isArraySubDest) {
                deepAssignArray(destSubValue, srcSubValue);
            } else {
                deepAssignObject(destSubValue, srcSubValue);
            }
        } else {
            destObject[key] = cloneValue(srcSubValue);
        }
    } else {
        destObject[key] = cloneValue(srcSubValue);
    }
}

function deepAssignObject(destObject, srcObject) {
    for (const key in destObject) {
        if (!(key in srcObject)) {
            delete destObject[key];
        }
    }

    for (const key in srcObject) {
        deepAssignProperty(destObject, key, srcObject[key]);
    }
}

function deepAssignArray(destArray, srcArray) {
    for (let i = 0; i < srcArray.length; i++) {
        deepAssignProperty(destArray, i, srcArray[i]);
    }

    if (destArray.length !== srcArray.length) {
        destArray.length = srcArray.length;
    }
}

export { deepAssignProperty, deepAssignObject, deepAssignArray };
